<div class="overlay">
  <div class="overlayDoor"></div>
  <div class="overlayContent">
      <img src="assets/image/loader.svg" alt="">
  </div>
</div>
